<template>
  <!-- Count 5 stars  -->
  <div class="rating-stats">
    <div :key="key" v-for="(value, key) in stats">
      <span class="rating-count mr-2">{{ value }}</span>
      <rating class="rating-lg" :rate="Number.parseInt(key)"></rating>
    </div>
  </div>
</template>

<script>
import Rating from '@/components/Rating'
export default {
  name: 'RatingStats',
  props: ['stats'],
  components: { rating: Rating }
}
</script>

<style lang="scss">
.rating-lg .fa {
  font-size: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/RatingStats.vue